<div class="container-fluid page-body-wrapper" style="padding-left: 260px; top: 50px; position: absolute; z-index: -1;">
    <!-- partial:../../partials/_sidebar.html -->

    <!-- partial -->
    <div class="main-panel">
        <div class="content-wrapper" style="padding: .5rem .8rem .5rem 3rem;">
            <div class="page-header">
                <h3 class="page-title text-primary">

                    Audit Output Report
                </h3>

            </div>

            <div class="row">
                <div class="col-md-2">
                    <select class="txt-input" [(ngModel)]="Type">
                        <option value="0" disabled>Search By</option>
                        <option value="1">BE Date</option>
                        <option value="2">Uploaded Date</option>
                    </select>
                </div>
                <div class="col-md-2" style="padding-left: 10px; padding-right: 10px;">
                    <input type="date" id="FromDate" [(ngModel)]="FromDate" class="txt-input" />
                  </div>
                  <div class="col-md-2" style="padding-left: 10px; padding-right: 10px;">
                    <input type="date" id="ToDate" [(ngModel)]="ToDate" class="txt-input" />
                  </div>
                <div class="col-md-2" style="padding-left: 10px;">
                    <button class="btnUpload" (click)="ViewReport()" id="btnHeader">View Report</button>
                </div>
            </div>
            <div class="text-center" style="padding-top: 30px;">
                <span [hidden]="isShownError" style="font-size:14px;color: red;">{{ErrorMsg}}</span>
                <span [hidden]="isShownSuccess" style="font-size:14px;color: green;">{{SuccessMsg}}</span>
              </div>
        </div>
        <div class="content-wrapper"> 
            <div class="row">
                <div class="col-lg-12 grid-margin">
                  <div class="card">
        
        
                    <div class="card-body" style="padding: 0rem 0rem;">
                      <div class="row">
        
                        <div class="col-12 grid-margin">
                          <div class="card">
                            <div class="card-body">
                              <div class="col-lg-12 form-inline"
                                style="border: 1px solid #9c9fa6; padding: 5px;background-color: #f0f0f1">
                                <div class="col-lg-5">
                                  <h4>Output Report</h4>
                                </div>
        
                                <div class="col-lg-7 " style="padding-right:0px;">
                                  <div class="form-group" style="float: right;">
                                    <div class="input-group">
                                      <input type="text" class="form-control" placeholder="Search..." aria-label="Search..."
                                        aria-describedby="basic-addon2" (keyup)="applyFilterInvItemDis($event.target.value)">
                                      <div class="input-group-append">
                                        <!-- <button class="btn btn-sm btn-gradient-danger" type="button">Search</button> -->
                                      </div>
                                    </div>
                                    <button type="button" class="btn btn-sm ">
                                      <img src="../../assets/ExportPDF.png" (click)="generatePdf()" />
        
                                    </button>
                                    <button type="button" class="btn  btn-sm" (click)="exportexcelInvoiceItemDis()">
                                      <img src="../../assets/ExportExcel.png" />
                                    </button>
                                  </div>
                                </div>
                              </div>
        
                              <div class="mat-elevation-z8" style="width: 100%; overflow: scroll;">
                                <table mat-table [dataSource]="dataSourceInvItemDis" style="width: 100%;" style="width: 100%;"
                                  matSort #TableInvItemDisSort="matSort">
                                  <ng-container matColumnDef="sno">
                                    <th mat-header-cell *matHeaderCellDef
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;">
                                      S.No </th>
                                    <td mat-cell *matCellDef="let item; let j = index" style="border: 1px solid !important;">
                                      {{(j +1)  + (TableInvItemDisPaginator.pageIndex * TableInvItemDisPaginator.pageSize) }}
                                    </td>
                                  </ng-container>
                                  <ng-container matColumnDef="bE_No">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> BE Number
                                    </th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;">
                                      {{element.bE_No}} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="invoiceNo">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> Invoice
                                      Number </th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px;border: 1px solid !important;">
                                      {{element.invoiceNo}}
                                    </td>
                                  </ng-container>
                                  <ng-container matColumnDef="invoiceDate">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> Invoice Date
                                    </th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px;border: 1px solid !important;">
                                      {{element.invoiceDate}}
                                    </td>
                                  </ng-container>
                                  <ng-container matColumnDef="partNo">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> Part Number BOE
                                    </th>
                                    <td mat-cell *matCellDef="let element" 
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;min-width: 150px; "
                                      [ngStyle]="{'background-color': element.partNo==element.partNoPOA ? 'white' : '#ff56b2'}" > {{element.partNo}} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="partNoPOA">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> Part Number POA
                                    </th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;min-width: 150px; "
                                      > {{element.partNoPOA}} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="description">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> Short
                                      Description BOE</th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;min-width: 170px;"
                                      [ngStyle]="{'background-color': element.description==element.shortDescriptionPOA ? 'white' : '#ff56b2'}" > {{element.description}}
                                    </td>
                                  </ng-container>
                                  <ng-container matColumnDef="shortDescriptionPOA">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> Short
                                      Description POA</th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;min-width: 170px;"
                                      > {{element.shortDescriptionPOA}}
                                    </td>
                                  </ng-container>
                                  <ng-container matColumnDef="longDescription">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> Long
                                      Description BOE</th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;min-width: 300px;"
                                      [ngStyle]="{'background-color': element.longDescription==element.longDescriptionPOA ? 'white' : '#ff56b2'}" >
                                      {{element.longDescription}} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="longDescriptionPOA">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> Long
                                      Description POA</th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;min-width: 300px;"
                                      >
                                      {{element.longDescriptionPOA}} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="unitPrice">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> Unit Price BOE
                                    </th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                                      [ngStyle]="{'background-color': element.unitPrice==element.unitPricePOA ? 'white' : '#ff56b2'}"> {{element.unitPrice}}
                                    </td>
                                  </ng-container>
                                  <ng-container matColumnDef="unitPricePOA">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> Unit Price POA
                                    </th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                                      > {{element.unitPricePOA}}
                                    </td>
                                  </ng-container>
                                  <ng-container matColumnDef="unit">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> Unit BOE </th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                                      [ngStyle]="{'background-color': element.unit==element.unitPOA ? 'white' : '#ff56b2'}"> {{element.unit}} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="unitPOA">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> Unit POA </th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                                      > {{element.unitPOA}} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="cnotn">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> Customs
                                      Notification BOE </th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                                      [ngStyle]="{'background-color': element.cnotn==element.cnotnPOA ? 'white' : '#ff56b2'}"> {{element.cNotn}} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="cnotnPOA">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> Customs
                                      Notification POA</th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                                      > {{element.cnotnPOA}} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="cntonSlNo">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> Customs
                                      Notification Sl No BOE</th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                                      [ngStyle]="{'background-color': element.cntonSlNo==element.cnotnSlNoPOA ? 'white' : '#ff56b2'}"> {{element.cNtonSlNo}}
                                    </td>
                                  </ng-container>
                                  <ng-container matColumnDef="cnotnSlNoPOA">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> Customs
                                      Notification Sl No POA</th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                                      > {{element.cnotnSlNoPOA}}
                                    </td>
                                  </ng-container>
                                  <ng-container matColumnDef="cusDtyRt">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> Custom Duty
                                      Rate BOE</th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                                      [ngStyle]="{'background-color': element.cusDtyRt==element.cusDtyRtPOA ? 'white' : '#ff56b2'}"> {{element.cusDtyRt}}
                                    </td>
                                  </ng-container>
                                  <ng-container matColumnDef="cusDtyRtPOA">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> Custom Duty
                                      Rate POA</th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                                      > {{element.cusDtyRtPOA}}
                                    </td>
                                  </ng-container>
                                  <ng-container matColumnDef="antiDmNotn">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> ADD
                                      Notification BOE</th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid  !important"
                                      [ngStyle]="{'background-color': element.antiDmNotn==element.antiDmNotnPOA ? 'white' : '#ff56b2'}"> {{element.antiDmNotn}}
                                    </td>
                                  </ng-container>
                                  <ng-container matColumnDef="antiDmNotnPOA">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> ADD
                                      Notification POA</th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid  !important"
                                      > {{element.antiDmNotnPOA}}
                                    </td>
                                  </ng-container>
                                  <ng-container matColumnDef="antiDmNotnSlno">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> ADD
                                      Notification Sl No BOE</th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid  !important;"
                                      [ngStyle]="{'background-color': element.antiDmNotnSlno==element.antiDmNotnSlNoPOA ? 'white' : '#ff56b2'}">
                                      {{element.antiDmNotnSlno}} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="antiDmNotnSlNoPOA">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> ADD
                                      Notification Sl No POA</th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid  !important;"
                                      >
                                      {{element.antiDmNotnSlNoPOA}} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="antiDmUnitPrice">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> ADD
                                      Notification Unit Price BOE</th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;;"
                                      [ngStyle]="{'background-color': element.antiDmUnitPrice==element.antiDmNotm1UnitPricePOA ? 'white' : '#ff56b2'}">
                                      {{element.antiDmUnitPrice}} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="antiDmNotm1UnitPricePOA">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> ADD
                                      Notification Unit Price POA</th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;;"
                                      >
                                      {{element.antiDmNotm1UnitPricePOA}} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="enotn">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> Exim
                                      Notification BOE </th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;;"
                                      [ngStyle]="{'background-color': element.enotn==element.enotn ? 'white' : '#ff56b2'}"> {{element.enotn}} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="enotnPOA">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> Exim
                                      Notification POA </th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;;"
                                      > {{element.enotn}} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="entonSlNo">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> Exim
                                      Notification Sl No BOE</th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                                      [ngStyle]="{'background-color': element.entonSlNo==element.enotnSlNoPOA ? 'white' : '#ff56b2'}"> {{element.entonSlNo}}
                                    </td>
                                  </ng-container>
                                  <ng-container matColumnDef="enotnSlNoPOA">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> Exim
                                      Notification Sl No POA</th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                                      > {{element.enotnSlNoPOA}}
                                    </td>
                                  </ng-container>
                                  <ng-container matColumnDef="excDtyRt">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> Excise Duty
                                      Rate BOE</th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                                      [ngStyle]="{'background-color': element.excDtyRt==element.exdtyRtPOA ? 'white' : '#ff56b2'}"> {{element.excDtyRt}}
                                    </td>
                                  </ng-container>
                                  <ng-container matColumnDef="exdtyRtPOA">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> Excise Duty
                                      Rate POA</th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                                      > {{element.exdtyRtPOA}}
                                    </td>
                                  </ng-container>
                                  <ng-container matColumnDef="hcvdRt">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> HCVD Rate BOE
                                    </th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                                      [ngStyle]="{'background-color': element.hcvdRt==element.hcvdRtPOA ? 'white' : '#ff56b2'}"> {{element.hcvdRt}} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="hcvdRtPOA">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> HCVD Rate POA
                                    </th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                                      > {{element.hcvdRtPOA}} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="eccRt">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> ECC Rate BOE
                                    </th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                                      [ngStyle]="{'background-color': element.eccRt==element.eccRtPOA ? 'white' : '#ff56b2'}"> {{element.eccRt}} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="eccRtPOA">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> ECC Rate POA
                                    </th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                                      > {{element.eccRtPOA}} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="sheccRt">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> SHECC Rate BOE
                                    </th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                                      [ngStyle]="{'background-color': element.sheccRt==element.sheccRtPOA ? 'white' : '#ff56b2'}"> {{element.sheccRt}} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="sheccRtPOA">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> SHECC Rate POA
                                    </th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                                      > {{element.sheccRtPOA}} </td>
                                  </ng-container>
                                  
                                  <ng-container matColumnDef="cecRt">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> CEC Rate BOE
                                    </th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                                      [ngStyle]="{'background-color': element.cecRt==element.cecRtPOA ? 'white' : '#ff56b2'}"> {{element.cecRt}} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="cecRtPOA">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> CEC Rate POA
                                    </th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                                      > {{element.cecRtPOA}} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="cshecRt">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> CSHEC Rate BOE
                                    </th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                                      [ngStyle]="{'background-color': element.cshecRt==element.csheRtPOA ? 'white' : '#ff56b2'}"> {{element.cshecRt}} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="csheRtPOA">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> CSHEC Rate POA
                                    </th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                                      > {{element.csheRtPOA}} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="swsRt">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> SWS Rate BOE
                                    </th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                                      [ngStyle]="{'background-color': element.swsRt==element.swsRtPOA ? 'white' : '#ff56b2'}"> {{element.swsRt}} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="swsRtPOA">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> SWS Rate POA
                                    </th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                                      > {{element.swsRtPOA}} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="igstNotn">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> IGST
                                      Notification BOE</th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                                      [ngStyle]="{'background-color': element.igstNotn==element.igstNotnPOA ? 'white' : '#ff56b2'}"> {{element.igstNotn}}
                                    </td>
                                  </ng-container>
                                  <ng-container matColumnDef="igstNotnPOA">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> IGST
                                      Notification POA</th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                                      > {{element.igstNotnPOA}}
                                    </td>
                                  </ng-container>
                                  <ng-container matColumnDef="igstNothSlNo">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> IGST
                                      Notification Sl No BOE</th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                                      [ngStyle]="{'background-color': element.igstNothSlNo==element.igstNotnSlNoPOA ? 'white' : '#ff56b2'}"> {{element.igstNothSlNo}}
                                    </td>
                                  </ng-container>
                                  <ng-container matColumnDef="igstNotnSlNoPOA">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> IGST
                                      Notification Sl No POA</th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                                      > {{element.igstNotnSlNoPOA}}
                                    </td>
                                  </ng-container>
                                  <ng-container matColumnDef="igstRt">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> IGST Rate BOE
                                    </th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                                      [ngStyle]="{'background-color': element.igstRt==element.igstRtPOA ? 'white' : '#ff56b2'}"> {{element.igstRt}} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="igstRtPOA">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> IGST Rate POA
                                    </th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                                      > {{element.igstRtPOA}} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="gstcNotn">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> GSTC
                                      Notification BOE</th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                                      [ngStyle]="{'background-color': element.gstcNotn==element.gstcNotnPOA ? 'white' : '#ff56b2'}"> {{element.gstcNotn}}
                                    </td>
                                  </ng-container>
                                  <ng-container matColumnDef="gstcNotnPOA">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> GSTC
                                      Notification POA </th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                                      > {{element.gstcNotnPOA}}
                                    </td>
                                  </ng-container>
                                  <ng-container matColumnDef="gstcNotnSlNo">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> GSTC
                                      Notification Sl No BOE</th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                                      [ngStyle]="{'background-color': element.gstcNotnSlNo==element.gstcNotnSlNoPOA ? 'white' : '#ff56b2'}"> {{element.gstcNotnSlNo}}
                                    </td>
                                  </ng-container>
                                  <ng-container matColumnDef="gstcNotnSlNoPOA">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> GSTC
                                      Notification Sl No POA</th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                                      > {{element.gstcNotnSlNoPOA}}
                                    </td>
                                  </ng-container>
                                  <ng-container matColumnDef="gstcRt">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> GSTC
                                      Notification Rate BOE </th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                                      [ngStyle]="{'background-color': element.gstcRt==element.gstcRtPOA ? 'white' : '#ff56b2'}"> {{element.gstcRt}} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="gstcRtPOA">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                      style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> GSTC
                                      Notification Rate POA</th>
                                    <td mat-cell *matCellDef="let element"
                                      style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                                      > {{element.gstcRtPOA}} </td>
                                  </ng-container>
        
        
                                  <tr mat-header-row *matHeaderRowDef="displayedColumnsInvItemDis"></tr>
                                  <tr mat-row *matRowDef="let row; columns: displayedColumnsInvItemDis;"></tr>
                                </table>
                                <mat-paginator #TableInvItemDisPaginator="matPaginator" [pageSizeOptions]="[5, 10,15, 20,30,40]"
                                  showFirstLastButtons></mat-paginator>
        
        
        
                              </div>
                            </div>
        
                          </div>
                        </div>
        
                      </div>
                      <div class="row">
                        <table id="tblExport" #tblExport [hidden]="ShownExport">
                          <tr>
                            <th>BE Number </th>
                            <th>Invoice Number</th>
                            <th>Invoice Date</th>
                            <th>Part Number</th>
                            <th>Short Description BOE</th>
                            <th>Short Description POA</th>
                            <th>Long Description BOE</th>
                            <th>LongDescription POA</th>
                            <th>Unit Price BOE</th>
                            <th>Unit Price POA</th>
                            <th>Unit BOE</th>
                            <th>Unit POA</th>
                            <th>Customs Notification BOE</th>
                            <th>Customs Notification POA</th>
                            <th>Customs Notification Sl No BOE</th>
                            <th>Customs Notification Sl No POA</th>
                            <th>Custom Duty Rate BOE</th>
                            <th>Custom Duty Rate POA</th>
                            <th>ADD Notification BOE </th>
                            <th>ADD Notification POA </th>
                            <th>ADD Notification Sl No BOE</th>
                            <th>ADD Notification Sl No POA</th>
                            <th>ADD Notification Unit Price BOE</th>
                            <th>ADD Notification Unit Price POA</th>
                            <th>Exim Notification BOE</th>
                            <th>Exim Notification POA</th>
                            <th>Exim Notification Sl No BOE</th>
                            <th>Exim Notification Sl No POA</th>
                            <th>Excise Duty Rate BOE</th>
                            <th>Excise Duty Rate POA</th>
                            <th>HCVD Rate BOE</th>
                            <th>HCVD Rate POA</th>
                            <th>ECC Rate BOE</th>
                            <th>ECC Rate POA</th>
                            <th>SHECC Rate BOE</th>
                            <th>SHECC Rate POA</th>
                            <th>CEC Rate BOE</th>
                            <th>CEC Rate POA</th>
                            <th>CSHEC Rate BOE</th>
                            <th>CSHEC Rate POA</th>
                            <th>SWS Rate BOE</th>
                            <th>SWS Rate POA</th>
                            <th>IGST Notification BOE</th>
                            <th>IGST Notification POA</th>
                            <th>IGST Notification Sl No BOE</th>
                            <th>IGST Notification Sl No POA</th>
                            <th>IGST Rate BOE</th>
                            <th>IGST Rate POA</th>
                            <th>GSTC Notification BOE</th>
                            <th>GSTC Notification POA</th>
                            <th>GSTC Notification Sl No BOE</th>
                            <th>GSTC Notification Sl No POA</th>
                            <th>GSTC Notification Rate BOE</th>
                            <th>GSTC Notification Rate POA</th>
                          </tr>
                  
                          <tr *ngFor="let ed of ExportData">
                            <td>{{ed.bE_No}} </td>
                            <td>{{ed.invoiceNo}}</td>
                            <td>{{ed.invoiceDate}}</td>
                            <td [ngStyle]="{'background-color': ed.partNo==ed.partNoPOA ? 'white' : '#ff56b2'}">{{ed.partNo}}</td>
                            <td>{{ed.partNoPOA}}</td>
                            <td  [ngStyle]="{'background-color': ed.description==ed.shortDescriptionPOA ? 'white' : '#ff56b2'}">{{ed.description}}</td>
                            <td>{{ed.shortDescriptionPOA}}</td>
                            <td [ngStyle]="{'background-color': ed.longDescription==ed.longDescriptionPOA ? 'white' : '#ff56b2'}">{{ed.longDescription}}</td>
                            <td>{{ed.longDescriptionPOA}}</td>
                            <td [ngStyle]="{'background-color': ed.unitPrice==ed.unitPricePOA ? 'white' : '#ff56b2'}">{{ed.unitPrice}}</td>
                            <td>{{ed.unitPricePOA}}</td>
                            <td [ngStyle]="{'background-color': ed.unit==ed.unitPOA ? 'white' : '#ff56b2'}">{{ed.unit}}</td>
                            <td>{{ed.unitPOA}}</td>
                            <td [ngStyle]="{'background-color': ed.cNotn==ed.cnotnPOA ? 'white' : '#ff56b2'}">{{ed.cNotn}}</td>
                            <td>{{ed.cnotnPOA}}</td>
                            <td [ngStyle]="{'background-color': ed.cNtonSlNo==ed.cnotnSlNoPOA ? 'white' : '#ff56b2'}">{{ed.cNtonSlNo}}</td>
                            <td>{{ed.cnotnSlNoPOA}}</td>
                            <td [ngStyle]="{'background-color': ed.cusDtyRt==ed.cusDtyRtPOA ? 'white' : '#ff56b2'}">{{ed.cusDtyRt}}</td>
                            <td>{{ed.cusDtyRtPOA}}</td>
                            <td [ngStyle]="{'background-color': ed.antiDmNotn==ed.antiDmNotnPOA ? 'white' : '#ff56b2'}">{{ed.antiDmNotn}}</td>
                            <td>{{ed.antiDmNotnPOA}}</td>
                            <td [ngStyle]="{'background-color': ed.antiDmNotnSlno==ed.antiDmNotnSlNoPOA ? 'white' : '#ff56b2'}">{{ed.antiDmNotnSlno}}</td>
                            <td>{{ed.antiDmNotnSlNoPOA}}</td>
                            <td [ngStyle]="{'background-color': ed.antiDmUnitPrice==ed.antiDmNotm1UnitPricePOA ? 'white' : '#ff56b2'}">{{ed.antiDmUnitPrice}}</td>
                            <td>{{ed.antiDmNotm1UnitPricePOA}}</td>
                            <td [ngStyle]="{'background-color': ed.enotn==ed.enotnPOA ? 'white' : '#ff56b2'}">{{ed.enotn}}</td>
                            <td>{{ed.enotnPOA}}</td>
                            <td [ngStyle]="{'background-color': ed.entonSlNo==ed.enotnSlNoPOA ? 'white' : '#ff56b2'}">{{ed.entonSlNo}}</td>
                            <td>{{ed.enotnSlNoPOA}}</td>
                            <td [ngStyle]="{'background-color': ed.excDtyRt==ed.exdtyRtPOA ? 'white' : '#ff56b2'}">{{ed.excDtyRt}}</td>
                            <td>{{ed.exdtyRtPOA}}</td>
                            <td [ngStyle]="{'background-color': ed.hcvdRt==ed.hcvdRtPOA ? 'white' : '#ff56b2'}">{{ed.hcvdRt}}</td>
                            <td>{{ed.hcvdRtPOA}}</td>
                            <td [ngStyle]="{'background-color': ed.eccRt==ed.eccRtPOA ? 'white' : '#ff56b2'}">{{ed.eccRt}}</td>
                            <td>{{ed.eccRtPOA}}</td>
                            <td [ngStyle]="{'background-color': ed.sheccRt==ed.sheccRtPOA ? 'white' : '#ff56b2'}">{{ed.sheccRt}}</td>
                            <td>{{ed.sheccRtPOA}}</td>
                            <td [ngStyle]="{'background-color': ed.cecRt==ed.cecRtPOA ? 'white' : '#ff56b2'}">{{ed.cecRt}}</td>
                            <td>{{ed.cecRtPOA}}</td>
                            <td [ngStyle]="{'background-color': ed.cshecRt==ed.csheRtPOA ? 'white' : '#ff56b2'}">{{ed.cshecRt}}</td>
                            <td>{{ed.csheRtPOA}}</td>
                            <td [ngStyle]="{'background-color': ed.swsRt==ed.swsRtPOA ? 'white' : '#ff56b2'}">{{ed.swsRt}}</td>
                            <td>{{ed.swsRtPOA}}</td>
                            <td [ngStyle]="{'background-color': ed.igstNotn==ed.igstNotnPOA ? 'white' : '#ff56b2'}">{{ed.igstNotn}}</td>
                            <td>{{ed.igstNotnPOA}}</td>
                            <td [ngStyle]="{'background-color': ed.igstNothSlNo==ed.igstNotnSlNoPOA ? 'white' : '#ff56b2'}">{{ed.igstNothSlNo}}</td>
                            <td>{{ed.igstNotnSlNoPOA}}</td>
                            <td [ngStyle]="{'background-color': ed.igstRt==ed.igstRtPOA ? 'white' : '#ff56b2'}">{{ed.igstRt}}</td>
                            <td>{{ed.igstRtPOA}}</td>
                            <td [ngStyle]="{'background-color': ed.gstcNotn==ed.gstcNotnPOA ? 'white' : '#ff56b2'}">{{ed.gstcNotn}}</td>
                            <td>{{ed.gstcNotnPOA}}</td>
                            <td [ngStyle]="{'background-color': ed.gstcNotnSlNo==ed.gstcNotnSlNoPOA ? 'white' : '#ff56b2'}">{{ed.gstcNotnSlNo}}</td>
                            <td>{{ed.gstcNotnSlNoPOA}}</td>
                            <td [ngStyle]="{'background-color': ed.gstcRt==ed.gstcRtPOA ? 'white' : '#ff56b2'}">{{ed.gstcRt}}</td>
                            <td>{{ed.gstcRtPOA}}</td>
                          </tr>
                        </table>
                      </div>
                    </div>
        
                  </div>
                </div>
              </div>
        </div>
        <footer class="footer">
            <div class="d-sm-flex justify-content-center">
              <span class="d-block d-sm-inline-block">
                © 2020 All Rights Reserved
                <a href="https://www.sysmedacmicrosoft.com/#!/" target="_blank" style="color:black;">
                  <img src="../../assets/Logo-V3.png" width="70" />
                </a>
      
              </span>
      
            </div>
          </footer>
    </div>
</div>